import { render, staticRenderFns } from "./LexinKeyboardLangVie.vue?vue&type=template&id=67f1a514&"
import script from "./LexinKeyboardLangVie.vue?vue&type=script&lang=js&"
export * from "./LexinKeyboardLangVie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports